








import { Component, Prop, Vue } from "vue-property-decorator";

import ICard from "@/components/models/ICard";

@Component
export default class Card extends Vue {
    @Prop(Object) card!: ICard;
}
